import { formatText } from 'core/i18n';
import './RAWizardContent.scss';
import React from 'react';
import { connect } from 'react-redux';

class RAWizardContentComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    getSteps() {
        const { steps } = this.props.RATestWizard;

        return steps;
    }

    getCurrentStep() {
        const { currentStep } = this.props.RATestWizard;

        return currentStep;
    }

    getCurrentSubStep() {
        const { currentSubStep } = this.props.RATestWizard;

        return currentSubStep;
    }

    showStep() {
        const steps = this.getSteps();
        const currentStepIndex = this.getCurrentStep();
        const subStep = steps?.[currentStepIndex].steps;
        const currentSubStepIndex = this.getCurrentSubStep();
        const $component = subStep?.[currentSubStepIndex].component;
        const step = <$component />;

        return step;
    }

    getTitle() {
        const steps = this.getSteps();
        const currentStepIndex = this.getCurrentStep();
        const title = steps?.[currentStepIndex].title;

        return title;
    }

    getSubtitle() {
        const steps = this.getSteps();
        const currentStepIndex = this.getCurrentStep();
        const subStep = steps?.[currentStepIndex].steps;
        const currentSubStepIndex = this.getCurrentSubStep();
        const subtitle = subStep?.[currentSubStepIndex].title;

        return subtitle;
    }

    render() {
        const step = this.showStep();
        const title = this.getTitle();
        const subtitle = this.getSubtitle();

        return (
            <div>
                <div className="wizard-content prospects-gutter">
                    <div className="wizard-content__title">{formatText(title)}</div>
                    <div className="wizard-content__subtitle">{subtitle && formatText(subtitle)}</div>
                </div>
                {step}
            </div>
        );
    }
}

export const RAWizardContent = connect(state => ({
    RATestWizard: state.raSuitabilityTestWizard,
    immSuitabilityTest: state.raSuitabilityTest,
    immCheckStatus: state.raCheckStatus,
}))(RAWizardContentComponent);
